<template>
  <div style="display: flex; width: 100%; height: 100%;">
    <div class="login-left">
      <!-- <img src="../assets/images/logo.png" style="width: 300px;" /> -->
      <img src="../assets/images/unpeace_blue.svg" style="width: 488px;" />
      <p>Smart Camp</p>
    </div>
    <div class="login-container">
      <div class="login-box">
        <h2 class="title">{{ $t('login') }}</h2>
        <form @submit.prevent="login">
          <div class="input-group">
            <label for="account" class="label">ID</label>
            <input
              v-model="account"
              id="account"
              placeholder="Enter your account"
              class="input-account"
            />
          </div>
          <div class="input-group">
            <label for="password" class="label">PASSWORD</label>
            <input
              v-model="password"
              type="password"
              id="password"
              placeholder="Enter your password"
              class="input-password"
            />
          </div>
          <div class="actions">
            <button type="submit" class="login-btn" :disabled="!isValid">{{ $t('login') }}</button>
            <!-- <a href="#" class="forgot-link">Forgot Password?</a> -->
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- 비밀번호 변경 모달 -->
  <div v-if="showPasswordModal" class="changepass">
    <div class="changepass-content">
      <div class="changepass-title">
        <h3>비밀번호 변경</h3>
        <img src="../assets/images/x_black.svg" />
      </div>
      <div class="changepass-form">
        <h2>계정 보호를 위해 비밀번호를 변경해주세요.</h2>
        <div style="display: flex; flex-direction: column; gap: 16px; width: 100%;">
          <div class="changepass-input">
            <input v-model="newPassword" type="password" placeholder="새 비밀번호" />
            <h3>새 비밀번호를 입력해주세요.</h3>
          </div>
          <div class="changepass-input">
            <input v-model="confirmPassword" type="password" placeholder="새 비밀번호 확인" />
            <h3>새 비밀번호를 한번 더 입력해주세요.</h3>
          </div>
        </div>
        <button @click="changePassword">변경하기</button>
      </div>
    </div>
  </div>

  <!-- 알림 컴포넌트 -->
  <NotificationPopup />
</template>
  
<script setup>
import NotificationPopup from '@/components/NotificationPopup.vue';
import { isLoginUse } from '@/router';
import { SendErrorLog, SessionTime } from '@/utils/GlobalUtility';
import { showNotification } from '@/utils/Notification';
import { GET_SERVER_REQUEST, SERVER_REQUEST } from '@/utils/ServerConnect';
import { Company_Name } from '@/utils/Setting';
import { computed, nextTick, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const accessToken = route.query.accessToken;

const router = useRouter();
const account = ref('');
const password = ref('');
const newPassword = ref("");
const confirmPassword = ref("");
const showPasswordModal = ref(false);
// const tempUserData = ref(null); // 임시 저장용
// 입력값이 모두 채워졌는지 확인하는 computed 속성
const isValid = computed(() => account.value.trim() !== "" && password.value.trim() !== "");

const simsysURL = (Company_Name.value === 'Simsys_Dev' || Company_Name.value === 'Qubicom_Dev') ? process.env.VUE_APP_SIMSYS_URL : process.env.VUE_APP_SIMSYS_REAL_URL;

const login = async () => {
  if (account.value === 'admin') {
    const expiryTime = new Date().getTime() + SessionTime;  // 1시간
    const sessionData = {
      isLoggedIn: true,
      expiry: expiryTime,
      loginid: account.value,
    };
    localStorage.setItem('session', JSON.stringify(sessionData));

    // 로그인 성공 시 Main.vue로 이동
    showNotification('Login success', 'alarm', 'top-center');
    router.push({ name: 'MainPage' });
  } else {
    try {
      if (isLoginUse.value) {
        const totalData = {
          user_account: account.value,
          password: password.value
        }
        const jsonData = JSON.stringify(totalData);
        const result = await SERVER_REQUEST('user', 'POST', jsonData, false, { 'Content-Type': 'application/json' }, '/check-password');

        if (result.message === 'OK') {
          let data = await GET_SERVER_REQUEST('user', '/'.concat(account.value));
          if (data.password_reset_required === 1) {
            showPasswordModal.value = true; // 비밀번호 변경 창 띄우기
            return;
          } else {
            loginSuccess();
          }
        } else {
          showNotification('Invalid credentials.', 'warn', 'top-center');
        }
      } else {
        const totalData = {
          mltrNo: account.value,
          pswd: password.value
        }
        const jsonData = JSON.stringify(totalData);

        const result = await fetch(`${simsysURL}/auth/login`, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: jsonData
                          })
        
        const data = await result.json(); // 🚀 응답이 올 때까지 기다림
        if (data.returnCode === "0000") {
          const result_token = await fetch(`${simsysURL}/auth/getUserInfo`, {
                                method: 'POST',
                                headers: {
                                  'Content-Type': 'application/x-www-form-urlencoded',
                                  'Authorization': `Bearer ${data.accessToken}`
                                },
                                body: null
                            })
          
          const data_final = await result_token.json(); // 🚀 응답이 올 때까지 기다림
          data_final.accessToken = data.accessToken;
          data_final.refreshToken = data.refreshToken;
          if (data_final.returnCode === "0000") loginSuccess(data_final.userInfo);
          else showNotification('Invalid credentials.', 'warn', 'top-center');
        } else showNotification('Invalid credentials.', 'warn', 'top-center');
      }
      
    } catch (error) {
      SendErrorLog('Login', error);
    }
  }
};

const changePassword = async () => {
  try {
    if (!newPassword.value || newPassword.value !== confirmPassword.value) {
      showNotification('비밀번호가 일치하지 않습니다.', 'error', 'top-center');
      return;
    }

    const totalData = {
      user_account: account.value,
      password: newPassword.value
    }
    const jsonData = JSON.stringify(totalData);
    const result = await SERVER_REQUEST('user', 'PUT', jsonData, false)
    if (result.message) {
      showPasswordModal.value = false;
      showNotification('비밀번호 변경이 완료되었습니다.', 'alarm', 'top-center');
    }
  } catch (error) {
    SendErrorLog('Login', error);
  }
};

const loginSuccess = (userInfo = null) => {
  const expiryTime = new Date().getTime() + SessionTime;  // 24시간
  const sessionData = {
    isLoggedIn: true,
    expiry: expiryTime,
    loginid: account.value,
    userinfo: userInfo
  };
  localStorage.setItem('session', JSON.stringify(sessionData));

  // 로그인 성공 시 Main.vue로 이동
  showNotification('Login success', 'alarm', 'top-center');
  router.push({ name: 'MainPage' });
};

onMounted(async () => {
  localStorage.removeItem('session');
  if (accessToken) {
    await nextTick(async () => {
      const result = await fetch(`${simsysURL}/auth/getUserInfo`, {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/x-www-form-urlencoded',
                              'Authorization': `Bearer ${accessToken}`
                            },
                            body: null
                        })
      
      const data = await result.json(); // 🚀 응답이 올 때까지 기다림

      if (data.returnCode === "0000") loginSuccess(data.userInfo);
      else showNotification('Invalid credentials.', 'warn', 'top-center');
    })
  }
});
</script>

<style scoped>
.login-left {
  flex: 1;
  width: 50%;
  min-width: 510px;
  align-content: center;
  background: #E3E9F2;

  p {
    font-size: 40px;
    font-weight: bold;
    color: #578DD9;
  }
}
.login-container {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 50%;
  min-width: 510px;
  max-width: 845px;
  height: 100%;
  background-color: #578DD9;
  flex-direction: column;
}

.login-box {
  width: 480px;
  height: 415px;
}

.title {
  text-align: left;
  font-size: 32px;
  color: #ffffff;
  margin: 0;
  margin-bottom: 40px;
}

.input-group {
  height: 91px;
  input {
    width: 100%;
    height: 51px;
    padding: 1rem;
    background-color: #FFFFFF;
    border: 1px solid #EBEBEB;
    border-radius: 8px;
    font-size: 1rem;
    box-sizing: border-box;
  }
  input:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
}

.label {
  display: block;
  font-size: 20px;
  font-weight: normal;
  text-align: left;
  color: #ffffff;
  margin-bottom: 17px;
}

.input-account {
  background:url('../assets/images/account.svg') no-repeat right 15px center;
}
.input-password {
  background:url('../assets/images/lock.svg') no-repeat right 15px center;
}

.actions {
  /* display: flex; */
  /* justify-content: space-between; */
  align-items: center;
}

.login-btn {
  width: 100%;
  height: 64px;
  background-color: transparent;
  color: #fff;
  border-radius: 8px;
  border: 1px solid #FFFFFF;
  cursor: pointer;
  font-size: 20px;
}
.login-btn:hover {
  background-color: #0056b3;
}
.login-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.forgot-link {
  color: #007bff;
  text-decoration: none;
  font-size: 0.9rem;
}

.forgot-link:hover {
  text-decoration: underline;
}

form {
  gap: 24px;
}

/* 모달 스타일 */
.changepass {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
.changepass-content {
  background: white;
  border-radius: 16px;
  text-align: center;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.2);
  width: 526px;
  height: fit-content;
}
.changepass-title {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 56px;
  padding: 16px;
  padding-left: 20px;
  padding-right: 20px;
  border-bottom: 1px solid #D9D9D9;

  h3 {
    margin: 0;
    color: #000000;
    font-size: 16px;
    font-weight: bold;
  }
}
.changepass-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  padding-left: 72px;
  padding-right: 72px;
  align-items: center;

  h2 {
    font-size: 20px;
    font-weight: normal;
    margin: 0;
  }
  button {
    width: 284px;
    height: 50px;
    color: #ffffff;
    background: #467AEB;
    border-radius: 8px;
    border: none;
    cursor: pointer;
  }
  button:hover {
    background-color: #0056b3;
  }
}
.changepass-input {
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;

  input {
    width: 382px;
    height: 50px;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #ccc;
  }
  h3 {
    color: #5C5C5C;
    font-size: 12px;
    font-weight: normal;
    margin: 0;
  }
}
</style>
